/*
 * Filename: field-rule-array.model.ts
 * Error store: This file represents the model for templates that will be displayed on homepage.
 */

import { types, ModelInstanceTypeProps, ModelProperties } from 'mobx-state-tree';


export const UtilityObject = types.model({
    componentTabState: types.boolean
}).actions((self: ModelInstanceTypeProps<ModelProperties>) => ({
    togglecomponentTabState(){
       self.componentTabState = !self.componentTabState;
    },
    setcomponentTabState(){
        self.componentTabState = true;
     }
}));
